import z from "zod";

const translationPath =
  "page.4uBus.integrationRule.integrationRuleParam.errors.";

const uBusAutomationParamSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().optional(),
  },
  { invalid_type_error: translationPath + "inclusion_rule_type" },
);

export const integrationRuleParamSchema = z
  .object({
    id: z.string().optional(),
    uBusAutomationParam: uBusAutomationParamSchema.nullish(),
    ifOneCode: z.string().nullish(),
    ifOneName: z.string().nullish(),
    ifTwoCode: z.string().nullish(),
    ifTwoName: z.string().nullish(),
    ifThreeCode: z.string().nullish(),
    ifThreeName: z.string().nullish(),
    ifFourCode: z.string().nullish(),
    ifFourName: z.string().nullish(),
    thenOneCode: z.string().min(1, translationPath + "required_field"),
    thenOneName: z.string().min(1, translationPath + "required_field"),
    thenTwoCode: z.string().nullish(),
    thenTwoName: z.string().nullish(),
    thenThreeCode: z.string().nullish(),
    thenThreeName: z.string().nullish(),
    thenFourCode: z.string().nullish(),
    thenFourName: z.string().nullish(),
  })
  .superRefine((val, ctx) => {
    if (!val.uBusAutomationParam) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: translationPath + "inclusion_rule_type",
        path: ["uBusAutomationParam"],
      });
    } else if (val.uBusAutomationParam.code === "3") {
      if (!val.thenTwoName) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "required_field",
          path: ["thenTwoName"],
        });
      }
      if (!val.thenTwoCode) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "required_field",
          path: ["thenTwoCode"],
        });
      }
    } else if (val.uBusAutomationParam.code === "2") {
      if (!val.thenTwoName) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "required_field",
          path: ["thenTwoName"],
        });
      }
      if (!val.thenTwoCode) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "required_field",
          path: ["thenTwoCode"],
        });
      }
    }
  });

export type TIntegrationRuleParamForm = z.infer<
  typeof integrationRuleParamSchema
>;
